import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import s from "./SearchOverlay.module.scss";

const SearchOverlay = ({ open, onClose }) => {
    const [keyword, setKeyword] = useState("");
    const navigate = useNavigate();

    const handleSearch = () => {
        if (!keyword.trim()) return;

        navigate(`/all-tours?kw=${encodeURIComponent(keyword)}`);
        onClose();
    };

    if (!open) return null;

    return (
        <div className={s.overlay}>
            <button className={s.close} onClick={onClose}>
                ✕
            </button>

            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-8 col-lg-6">

                        <div className={`input-group input-group-lg ${s.searchWrapper}`}>
                            <input
                                autoFocus
                                type="text"
                                className="form-control border-0"
                                placeholder="ツアーを検索…"
                                value={keyword}
                                onChange={(e) => setKeyword(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") handleSearch();
                                }}
                            />

                            <button
                                className="  px-4"
                                onClick={handleSearch}
                            >
                                <i className="fa fa-search"></i>
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchOverlay;